import { render, staticRenderFns } from "./StaffFranchiseManager.vue?vue&type=template&id=6d7287a8&"
import script from "./StaffFranchiseManager.vue?vue&type=script&lang=ts&"
export * from "./StaffFranchiseManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports